import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import * as Partials from './partials'
import * as UI from '../components'
import { dataToArray, formatBigNumber } from '../helpers'

class Receipt extends React.Component {
  render() {
    const { purchase, storefront, trackPurchaseMore } = this.props

    return (
      <div>
        <UI.Card>
          <UI.Text center weight="bold" size="large">
            Congrats! You've bought {storefront.tokenName}!
          </UI.Text>

          <UI.Divider />

          <UI.Text center>
            Upon completion, a receipt of your purchase will be sent to your
            email.
          </UI.Text>

          <UI.Divider hidden />

          {purchase.tokensClaimed ? (
            <UI.Text center size="huge">
              {formatBigNumber(purchase.tokensClaimed)} {storefront.tokenName}
            </UI.Text>
          ) : (
            <UI.Text center size="huge">
              Token amount will be calculated as payments complete
            </UI.Text>
          )}

          <UI.Divider hidden />

          <UI.Text center>
            <Partials.PaymentsList payments={dataToArray(purchase.payments)} />
          </UI.Text>

          <UI.Divider hidden />

          <UI.Text center>
            <UI.Button to="/" onClick={trackPurchaseMore}>Purchase more {storefront.tokenName}</UI.Button>
          </UI.Text>
        </UI.Card>

        <UI.Card>
          <UI.Text center size="large">
            Timeline of Next Events
          </UI.Text>

          <UI.Divider />

          <ul>
            <li>
              The sale will continue until the sooner of all tokens are sold or
              sale end date is reached
            </li>
            <li>
              The token will then be generated and distributed. The goal is to
              do that within 30 days
            </li>
            <li>
              Updates along the way will be provided on a weekly basis via email
              and the blog. We're on it!
            </li>
            <li>
              Stop in and say hi --{' '}
              <UI.Link to={storefront.telegramLink} target="blank">
                telegram
              </UI.Link>
            </li>
          </ul>
        </UI.Card>
      </div>
    )
  }
}

const selectors = null

const actions = (dispatch) => ({
  trackPurchaseMore: async () => {
    dispatch({ type: 'PURCHASE_MORE', track: {} })
  },
})

export default compose(
  connect(selectors, actions),
)(Receipt)



// WEBPACK FOOTER //
// ./src/screens/Receipt.js